module.exports = __webpack_public_path__ + "static/media/Fair Practice Code.df091d7e.pdf";